import React from "react";
import Spacing from "../Spacing";
import SectionHeading from "../SectionHeading";

const solutions = [
  {
    title: "Gamer Exchange",
    subtitle: "Sports Betting Platform",
    description:
      "A dynamic sports betting platform offering a wide range of betting categories, real-time odds, and instant results. With a secure and intuitive app, users can place bets, manage funds, and stay connected to the latest sports action.",
  },
  {
    title: "Online Lottery",
    subtitle: "Digital Lottery Experience",
    description:
      "Reimagines the lottery experience with a sleek, user-friendly e-commerce platform. Players can easily purchase tickets, check results, and follow upcoming draws. It is designed to be accessible and enjoyable for everyone.",
  },
  {
    title: "MA Quick Scanner",
    subtitle: "Smart Retailer Tools",
    description:
      "A smart, QR code-based solution for lottery retailers, streamlining ticket management and sales tracking. It provides real-time reporting, monitors unsold inventory, and enhances operational accuracy—empowering retailers with greater control and efficiency.",
  },
  {
    title: "E-commerce",
    subtitle: "Unified Digital Marketplace",
    description:
      "A comprehensive e-commerce platform designed to empower startups, family-run businesses, and established brands through a unified digital marketplace. The platform enables seamless vendor onboarding, product management, secure online sales, and efficient order processing. It also supports business growth by integrating relevant government initiatives and digital commerce solutions, helping businesses expand their reach and achieve sustainable growth.",
  },
  {
    title: "AI Automation Services",
    subtitle: "Intelligent Business Operations",
    description:
      "We deliver end-to-end AI-driven automation solutions designed to streamline and optimize business operations across functions. Our platforms leverage advanced technologies and workflow orchestration to build highly customized, scalable systems tailored to specific business requirements. From process automation and decision intelligence to customer engagement and analytics, we enable data-driven, efficient, and autonomous business operations.",
  },
  {
    title: "Political Digital Solutions",
    subtitle: "Secure Campaign Platforms",
    description:
      "We design and develop secure, scalable mobile applications and web platforms for political parties. Our solutions include membership management, campaign management, volunteer coordination, event management, digital communication and real-time analytics, enabling organizations to engage effectively with their supporters and streamline operations.",
  },
];

export default function Solutions() {
  return (
    <section id="solutions" className="ballLightSolutions">
      <div className="container">
        <h2 className="text-center solutionsTitle">
          Building Intelligent Platforms for Gaming and Interactive Entertainment
        </h2>
        <SectionHeading variant="cs-style1 text-center" />
        <Spacing lg="30" md="20" />
        <p className="solutionsIntro text-center">
          Charles Technologies designs and develops cutting-edge platforms that
          power the future of digital gaming and entertainment. From immersive
          sports betting to modern lottery systems and smart retail tools, our
          solutions combine innovation, scalability, and strong backend
          technology to deliver seamless and engaging user experiences.
        </p>
        <Spacing lg="60" md="40" />
        <div className="solutionsGrid">
          {solutions.map((solution, index) => (
            <div className="solutionCard" key={index}>
              <h4 className="solutionCardTitle">{solution.title}</h4>
              <h6 className="solutionCardSubtitle">{solution.subtitle}</h6>
              <p className="solutionCardText">{solution.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
